import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import { StudentAuthProvider } from './context/StudentAuthContext';

const onRedirectCallback = (appState) => {
  // Restore the user to their intended page after Auth0 login redirect.
  // window.history.replaceState avoids adding an extra entry in browser history.
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience:     process.env.REACT_APP_AUTH0_AUDIENCE,
        scope: 'openid profile email read:templates create:templates update:templates delete:templates'
      }}
      cacheLocation="memory"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {/* Cognito student-session state — independent of, and available
          alongside, the Auth0 session above. See context/StudentAuthContext.jsx */}
      <StudentAuthProvider>
        <App />
      </StudentAuthProvider>
    </Auth0Provider>
  </React.StrictMode>
);